import {DOCUMENT, LocationStrategy} from '@angular/common';
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {AppDestroyAction} from '@client/actions/app-actions';
import {getContractCreateStep, getNetworkStatusIsOnline} from '@client/selectors';
import {select, Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Router, NavigationEnd} from "@angular/router";
import {AngularFireAuth} from "@angular/fire/auth";

@Component({
  selector: 'spaq-root',
  template: `
    <main *ngIf="!(network$ | async)" class="h-100 d-flex flex-column justify-content-between align-items-center ">
      <div class="pt-4 d-flex msg text-center">Vous êtes hors-ligne. SPAQ se reconnectera lorsqu'une connexion Internet
        sera détectée.
      </div>
      <div class="d-flex align-items-center flex-column h-auto">
        <img
          class=""
          src="data:image/jpeg;base64,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"
          alt=""
        />
      </div>
      <div>.</div>
    </main>
    <main *ngIf="network$ | async" class="h-100" kendoRippleContainer>
      <div class="k-con" kendoDialogContainer></div>
      <!-- <simple-notifications [options]="options"></simple-notifications> -->
      <router-outlet></router-outlet>
    </main>
    <div class="k-con" kendoDialogContainer></div>
  `,
  styles: [
      `
      .k-con {
        z-index: 100000;
      }

      .msg {
        max-width: 600px;
        font-size: 1.6rem;
        color: #444444;
      }
    `
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  network$ = this.store.pipe(select(getNetworkStatusIsOnline));
  contractStep$ = this.store.pipe(select(getContractCreateStep));
  public options = {
    position: ['bottom', 'right'],
    timeOut: 3000,
    lastOnBottom: true,
    clickToClose: true,
    showProgressBar: true
  };
  title = 'app';
  isPopState = false;

  constructor(translate: TranslateService, private store: Store<any>, @Inject(DOCUMENT) protected document: Document, protected aff: AngularFireAuth, private locStrat: LocationStrategy, private router: Router) {
    translate.setDefaultLang('fr');
    // aff.database.app.auth().useEmulator('http://localhost:9099/');
    // aff.database.app.database('http://localhost:9000/?ns=spaq-mobile-stage').useEmulator('localhost', 9000);
    translate.use('fr');
  }

  ngOnDestroy() {
    this.store.dispatch(new AppDestroyAction());
  }

  ngOnInit() {
    window.location.href = 'https://ciussse-chus.spaq.com';
    this.locStrat.onPopState(() => {
      this.isPopState = true;
    });
    this.contractStep$.subscribe(
      () => {
        window.scrollTo(0, 0);
      }
    );
    this.router.events.subscribe(event => {
      // Scroll to top if accessing a page, not via browser history stack
      if (event instanceof NavigationEnd && !this.isPopState) {
        window.scrollTo(0, 0);
        this.isPopState = false;
      }

      // Ensures that isPopState is reset
      if (event instanceof NavigationEnd) {
        this.isPopState = false;
      }
    });
  }
}
